// utils/disputeNavigation.js

/**
 * Navigate to application page with specific dispute highlighted
 * This can be used from notification components
 */
export const navigateToDispute = (navigate, applicationId, disputeId, userRole = null) => {
  if (navigate && applicationId && disputeId) {
    // Navigate to appropriate application details page based on user role
    let basePath = '/application';
    
    // Hospital users should go to their specific route
    if (userRole === 'Hospital') {
      basePath = '/hospital/application';
    } else if (userRole === 'Doctor') {
      basePath = '/doctor/application';
    } else if (userRole === 'PolicyWriter') {
      basePath = '/policy/application';
    } else if (userRole === 'FinancialTeam') {
      basePath = '/financial/application';
    } else if (userRole === 'LeadGenerator') {
      basePath = '/lead/application';
    }
    
    // Navigate to application details with dispute highlight
    navigate(`${basePath}/${applicationId}?highlightDispute=${disputeId}`);
  }
};

/**
 * Extract dispute ID from URL parameters
 */
export const getHighlightedDisputeId = (searchParams) => {
  return searchParams?.get('highlightDispute') || null;
};

/**
 * Generate notification click handler for dispute notifications
 */
export const createDisputeNotificationHandler = (navigate, userRole = null) => {
  return (notification) => {
    if (notification.type === 'dispute' && notification.applicationId && notification.disputeId) {
      navigateToDispute(navigate, notification.applicationId, notification.disputeId, userRole);
    }
  };
};

/**
 * Helper to format dispute notification message
 */
export const formatDisputeNotificationMessage = (dispute, userRole) => {
  const isForHospital = userRole === 'Hospital';
  
  if (isForHospital) {
    return {
      title: `New Query Raised: ${dispute.title || 'Application Query'}`,
      message: `You have received a new query for an application. Click to respond.`,
      actionText: 'Respond to Query'
    };
  } else {
    return {
      title: `Query Update: ${dispute.title || 'Application Query'}`,
      message: `There's an update on a dispute you're involved in.`,
      actionText: 'View Details'
    };
  }
};
